import { Login } from './login'

export const whitelabelService = { Login }
